export default __webpack_public_path__ + "static/media/ad-4.7fa7b669.png";